import type { HelpTopic } from '@sirocco/shared';
import { requireUid } from './auth';
import { paths } from './paths';
import { newKey, SiroccoDataError, updateValues } from './rtdb';
import { t } from '../i18n';

/**
 * Aide et signalements.
 *
 * Un message d'aide est un signalement comme un autre : il finit dans
 * `reports/`, dont la regle demande seulement que l'expediteur soit
 * celui qui ecrit. Pas de nouvelle branche, donc pas de nouvelle regle a
 * deployer avant que l'ecran fonctionne.
 */

/** Longueur au-dela de laquelle personne ne lit plus rien. */
const MAX_LENGTH = 1200;

export async function sendHelpRequest(topic: HelpTopic, message: string): Promise<string> {
  const reporterId = requireUid();
  const content = message.trim();
  if (!content) {
    throw new SiroccoDataError(t.profil.aideErreurs.vide, 'invalid', 'message');
  }

  const reportId = newKey(paths.reports());
  await updateValues({
    [`${paths.reports()}/${reportId}`]: {
      type: 'help',
      topic,
      message: content.slice(0, MAX_LENGTH),
      reporterId,
      createdAt: Date.now(),
    },
  });
  return reportId;
}
